import configAuth from '../../shared/auth';
const auth = configAuth();
export default auth;
